function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 311 311"
}, props), React.createElement("g", {
  clipPath: "url(#clip0_10498_3533)"
}, React.createElement("path", {
  d: "M271 0H40C17.909 0 0 17.909 0 40v231c0 22.091 17.909 40 40 40h231c22.091 0 40-17.909 40-40V40c0-22.091-17.909-40-40-40z",
  fill: "#283451"
}), React.createElement("path", {
  d: "M202.337 246c-25.71 0-57.22-17.296-88.743-48.697C82.71 166.42 65 133.881 65 108.03c0-13.37 4.628-24.781 13.756-33.906l.732-.734C84.902 67.976 90.7 65 95.824 65c4.497 0 8.274 2.263 11.544 6.916l20.441 30.135c4.746 6.974 3.855 14.271-2.512 20.537l-7.379 7.166c-3.774 3.773-3.602 9.39-1.832 13.006 3.059 5.794 11.916 16.483 23.665 28.529 12.726 13.048 23.086 20.717 28.536 23.542a11.771 11.771 0 005.335 1.277c2.92 0 5.585-1.104 7.498-3.117l7.292-7.399c3.523-3.638 7.36-5.488 11.399-5.488 2.994 0 6.065 1.036 9.122 3.075l30.014 20.429c4.678 3.161 7.053 7.055 7.053 11.568 0 5.198-2.892 10.731-8.598 16.437a4.247 4.247 0 01-.376.335l-.128.197-.127.101C227.645 241.37 216.057 246 202.337 246z",
  fill: "#fff"
})), React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0_10498_3533"
}, React.createElement("path", {
  fill: "#fff",
  d: "M0 0h311v311H0z"
})))));